$spacing: 6px;

.wrapper {
  padding: 0px $spacing $spacing $spacing;

  &.isHidden {
    padding-top: 0;
    padding-bottom: 0;
    height: 0;
  }
}

.form {
  flex: 1;
  position: relative;
  height: auto;
  transform: translateY(0);
  transition: 0.5s ease all;

  &.isHidden {
    height: 0;
    // go down while collapse appears to go up
    transform: translateY(100%);
  }
}

.input {
  font-size: 15px;
  width: 100%;
  padding: 6px 30px 6px 8px;
  border: none;
  border: 1px solid #d7d4de;
  background-color: white;
  border-radius: 4px;
}

.button {
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
  bottom: 0;
  background: transparent;
  display: flex;
  align-items: center;
  border: none;
  padding: 6px 12px;
}

.button:focus {
  outline-offset: 0px;
}

.icon {
  width: 16px;
  height: 16px;
}

.download {
  margin-left: 8px;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
}

.download path {
  fill: #201f23;
  transition: 0.15s fill;
}

.download:hover path,
.download:focus path {
  fill: #e6006f;
}
